// @flow

// types
type GenericAction = Object

const eventDefinitionsMap = (rAction: GenericAction) => {
  switch (rAction.type) {
    case 'ADD_GTM_EVENT':
      return (action: GenericAction, prevState: Object) => {
        return {
          hitType: 'event',
          event: 'gaEvent',
          eventCategory: 'Callback Form',
          eventAction: action.action,
          eventLabel: action.label,
          eventValue: action.value ? action.value : 'unknown value'
        }
      }
    case 'SET_GTM_PAGE_VIEW':
      return (action: GenericAction) => {
        return {
          hitType: 'pageview',
          event: 'pageview',
          page: window.location.pathname || action.page,
          title: action.title ? `${action.title}` : 'unknown title',
        }
      }
    case 'ON_SEND_CALLBACK_REQUEST_SUCCESS':
      return () => {
        return {
          hitType: 'event',
          event: 'gaEvent',
          eventAction: 'Send',
          eventCategory: 'Callback Form',
          eventLabel: rAction.callbackType === 'leaving' ? 'Leaving' : 'Popup',
        }
      }
  }
}

export default eventDefinitionsMap
